export default __webpack_public_path__ + "static/media/forbidden-bw.0898ceab.png";